<template>
<div class="canvas-border">
	<h2>Floor Area</h2>
	<v-stage ref="stage" :config="stageSize" class="img-content">
		<v-layer ref="layer">
			<v-image class="image-canvas-popUp"
			:config="{
				image: image,
				width: imageWidth,
				height: imageHeight
			}"
			/>
			<!-- <v-image :config="{ image: eSlab }" v-if="wichHelp === 'ExistingSlab' " /> -->
			<v-image class="image-canvas-popUp"
				:config="{
				image: upLayer,
				width: imageWidth,
				height: imageHeight
				}" />
		</v-layer>
	</v-stage>
		<!-- <div class="description" :class="{ marginUpper: isDescriptionTablet }">
			<span class="span-asterics" :class="{ 'existing-color': color === 'existing', 'addition-color': color === 'addition', 'garage-color': color === 'garage' }">
				*
			</span>
			<span :class="{ 'existing': color === 'existing', 'addition': color === 'addition', 'garage': color === 'garage' }">
				Description: {{description}}
			</span>
		</div> -->
</div>
</template>

<script>

import base from '@/common/img/floorAreaSvgReference.jpg'
import eSlabImage from '@/common/img/e_slab.png'
import eRaisedImage from '@/common/img/e_raised.png'
import eExposedImage from '@/common/img/e_exposed.png'
import eOverGarage from '@/common/img/e_overGarage.png'
import eOverAddition from '@/common/img/e_overAddition.png'

import aOverGarage from '@/common/img/a_overGarage.png'
import aSlab from '@/common/img/a_slab.png'
import aRaised from '@/common/img/a_raised.png'
import aExposed from '@/common/img/a_exposed.png'
import aGarage from '@/common/img/a_garage.png'

import SlabExisting from '@/common/img/E_Slab_existing.png'
// import RaisedExisting from '@/common/img/E_Raised_existing.png'
import ExposedExisting from '@/common/img/E_Exposed_existing.png'
import OverGarageExisting from '@/common/img/E_OverGarage_existing.png'
// import OverAdditionExisting from '@/common/img/E_OverAddition_existing.png'
import GarageExisting from '@/common/img/garage_existing.png'
import ExistingTotalArea from '@/common/img/floorAreaSvgReference_existing.jpg'

const upLayerConst = new window.Image()
// var DesktopWidth = 800
// var DesktopHeight = 300

export default {
	name: 'svgFloorReference',
	data () {
		return {
			windowWidthPage: '',
			currentWidth: 'Desktop',
			stageSize: {
				width: 800,
				height: 300
			},
			isDescriptionTablet: false,
			imageWidth: 729,
			imageHeight: 253,
			image: null,
			upLayer: null,
			color: '',
			description: 'This description ...',
			wichBg: ''
		}
	},
	props: [
		'wichHelp'
	],
	created: function () {
		const baseImage = new window.Image()
		this.wichBg = this.wichHelp
		let imageBg
		if (this.wichBg === 'e_exposedSpace' || this.wichBg === 'e_areaOverenclosedGarage' || this.wichBg === 'e_slab' || this.wichBg === 'e_encGarageArea') {
			imageBg = ExistingTotalArea
		} else {
			imageBg = base
		}
		baseImage.src = imageBg
		baseImage.onload = () => {
			// set image only when it is loaded
			this.image = baseImage
		}
		let getProp = this.wichHelp
		upLayerConst.src = this.returnCorrectOption(getProp)
		upLayerConst.onload = () => {
			// set image only when it is loaded
			this.upLayer = upLayerConst
			window.addEventListener('resize', this.responsiveImagePopUp())
			this.responsiveImagePopUp()
		}
	},
	mounted: function () {
		this.getWindowWidth()
		window.addEventListener('resize', this.getWindowWidth)		// console.debug(`Now is mounted`)
	},
	methods: {
		getWindowWidth () {
			let widthPage = document.documentElement.clientWidth
			// EventBus.$emit('get-window-width', widthPage)
			// console.log(`this.imageWidth is ${widthPage}`)
			this.responsiveImagePopUp()
			this.windowWidthPage = widthPage
		},
		responsiveImagePopUp () {
			let widthPage = this.windowWidthPage
			if (widthPage > 991) {
				this.imageWidth = 729
				this.imageHeight = 253

				this.stageSize.width = 800
				this.stageSize.height = 300
				this.isDescriptionTablet = false
				this.currentWidth = 'desktop'
			} else if (widthPage < 991 && widthPage > 768) {
				// console.count(`responsiveImagePopUp is for tablet...width: ${this.stageSize.width} height: ${this.stageSize.height}`)
				this.imageWidth = 429
				this.imageHeight = 155

				this.stageSize.height = 150
				this.isDescriptionTablet = true
				this.currentWidth = 'tablet'
			} else if (widthPage < 768) {
				this.imageWidth = 429
				this.imageHeight = 163

				this.stageSize.width = 500
				this.stageSize.height = 250
				this.isDescriptionTablet = true
				this.currentWidth = 'mobile'
			}
		},
		returnCorrectOption (value) {
			switch (value) {
			case 'ExistingSlab':
				this.color = 'existing'
				return eSlabImage
			case 'ExistingRaised':
				this.color = 'existing'
				return eRaisedImage
			case 'ExistingExposed':
				this.color = 'existing'
				return eExposedImage
			case 'ExistingOverGarage':
				this.color = 'existing'
				return eOverGarage
			case 'ExistingOverAddition':
				this.color = 'existing'
				return eOverAddition
			case 'additionSlab':
				this.color = 'addition'
				return aSlab
			case 'additionRaised':
				this.color = 'addition'
				return aRaised
			case 'additionExposed':
				this.color = 'addition'
				return aExposed
			case 'additionOverGarage':
				this.color = 'addition'
				return aOverGarage
			case 'additionGarageTotalArea':
				this.color = 'garage'
				return aGarage
			case 'e_exposedSpace':
				this.color = 'E_existing'
				return ExposedExisting
			case 'e_areaOverenclosedGarage':
				this.color = 'E_existing'
				return OverGarageExisting
			case 'e_slab':
				this.color = 'E_existing'
				return SlabExisting
			case 'e_encGarageArea':
				this.color = 'E_existing'
				return GarageExisting
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/take-off-tool/tabs-components/pops/floorReferenceSvg.vue